import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    FirstButton,
    PrevButton,
    NextButton,
    LastButton
} from '_components'
import styles from './SearchResults.module.css'
import { searchActions } from '_actions';
import { SearchResult } from './SearchResult'

class SearchResults extends React.Component {

    getLastPage() {
        var lastPage = Math.floor(this.props.totalResults / this.props.resultsPerPage);
        if (this.props.totalResults % this.props.resultsPerPage > 0) {
            lastPage++;
        }
        return lastPage;
    }

    setPage(newPage) {
        if (newPage !== this.props.page) {
            this.props.search(this.props.searchStr, newPage);
        }
    }

    render() {
        var firstPage = 1;
        var prevPage = this.props.page - 1 < 1 ? 1 : this.props.page - 1;
        var lastPage = this.getLastPage();
        var nextPage = this.props.page + 1 > lastPage ? lastPage : this.props.page + 1;

        return (
            <div>
                <div className={styles.results}>
                    <span className={styles.header}>
                        <span className={styles.header_column} style={{ width: 50 }}/>
                        <span className={styles.header_column} style={{ width: 130 }}>SYS#</span>
                        <span className={styles.header_column} style={{ width: 130 }}>Last Name</span>
                        <span className={styles.header_column} style={{ width: 130 }}>First Name</span>
                        <span className={styles.header_column} style={{ width: 130 }}>DOB</span>
                        <span className={styles.header_column} style={{ width: 130 }}>SSN</span>
                        <span className={styles.header_column}>Location</span>
                    </span>

                    {Object.keys(this.props.results)
                        .sort((a, b) => {
                            return this.props.results[a].id > this.props.results[b].id ? 1 : -1;
                        })
                        .map(id => {
                            const result = this.props.results[id];
                            return <SearchResult key={result.id} id={result.id} />
                        })
                    }
                </div>
                <div style={{ width: '100%' }}>
                    <div className={styles.nav_buttons}>
                        <span className={styles.nav_button} style={{ marginRight: '5px' }}><FirstButton size='small' onClick={() => this.setPage(firstPage)} /></span>
                        <span className={styles.nav_button} style={{ marginRight: '5px' }}><PrevButton size='small' onClick={() => this.setPage(prevPage)} /></span>
                        <span className={styles.page_label}>Page {this.props.page} of {lastPage}</span>
                        <span className={styles.nav_button} style={{ marginRight: '5px' }}><NextButton size='small' onClick={() => this.setPage(nextPage)} /></span>
                        <span className={styles.nav_button}><LastButton size='small' onClick={() => this.setPage(lastPage)} /></span>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        searchStr: state.ui.search.searchStr,
        results: state.entities.search,
        page: state.ui.search.page,
        totalResults: state.ui.search.totalResults,
        resultsPerPage: state.entities.masterData.PROPS['PTERO_SEARCH_RESULTS_COUNT'] ? state.entities.masterData.PROPS['PTERO_SEARCH_RESULTS_COUNT'].PRVALUE : 0
    };
}


function mapDispatchToProps(dispatch) {
    return {
        search: bindActionCreators(searchActions.search, dispatch)
    };
}

const connectedSearchResults = connect(mapStateToProps, mapDispatchToProps)(SearchResults);
export { connectedSearchResults as SearchResults };

